import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import * as S from "./styles";
import ParticipanteLayout from '../../Layouts/ParticipanteLayout';
import { useToken } from '../../Components/TokenContext';
import { Produtos } from '../../Components/Produtos';
import { InitialInfo } from '../../Components/InitialInfo';
function Premios() {
    const [premios, setPremios] = useState([]);
    const { tokenData } = useToken();
    const [error, setError] = useState('');
    const baseUrl = process.env.REACT_APP_API_URL;
    const [loading, setLoading] = useState(true);
    const accessToken = localStorage.getItem('access_token');
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        const modalExpire = localStorage.getItem('notice_expire');

        if (!modalExpire || Date.now() > parseInt(modalExpire)) {
            setShowModal(true);
        }
    }, []);

    const closeModal = () => {
        setShowModal(false);
        localStorage.setItem('notice_expire', (Date.now() + 21600000).toString());
    };


    const fetchPremios = async () => {
        try {
            const response = await fetch(`${baseUrl}/premios`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                },
            });

            if (!response.ok) {
                setLoading(false);
                setError('Erro ao buscar os seus prêmios.')
                return;
            }

            const data = await response.json();
            setPremios(data.premios);

        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPremios();
    }, []);

    return (
        <S.Container>
            <section className="overflow-hidden pb-32">
                <div className="container max-w-[1410px]">
                    <InitialInfo />
                    <div className="relative z-[1]">
                        {loading ? (
                            <div className={`relative flex items-center justify-center transition-opacity duration-300`}>
                                <div className="mt-20 h-12 w-12 animate-spin rounded-full border-4 border-solid border-tertiary border-t-transparent"></div>
                            </div>
                        ) : (
                            <div className='premioContainer'>
                                {premios && premios.length > 0 && (
                                    premios.map((item, k) => (
                                        <Produtos data={item} key={k} />
                                    ))
                                )}
                            </div>
                        )}
                        {error && (
                            <p>{error}</p>
                        )}
                        {showModal && tokenData.carrinhoCount > 0 && (
                            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
                                <div className="bg-white p-6 rounded-md shadow-lg relative w-[95%] sm:w-[90%] max-w-md">
                                    <button
                                        onClick={closeModal}
                                        className="absolute top-2 right-2 text-gray-500 hover:text-gray-800"
                                    >
                                        ✕
                                    </button>
                                    <h2 className="text-lg font-bold mb-4 text-center">Não se esqueça!
                                    </h2>
                                    <p className='mb-4 text-center'>Você possui itens no carrinho. Confirme os itens desejados para garantir seus prêmios.
                                    </p>
                                    <button
                                        onClick={closeModal}
                                        className="flex justify-center items-center m-auto w-fit bg-primary text-white py-2 px-4 rounded-md hover:bg-opacity-80 disabled:bg-opacity-80 disabled:cursor-not-allowed"
                                    >
                                        Ok
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </section>
        </S.Container>
    );
}

export default Premios;